import { Injectable } from '@angular/core';
import { Item } from '../item.interface';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class KeyValueService {

  private addItemListener = new Subject();
  private deleteItemListener = new Subject();

  constructor() { }

  public listenAddItem() {
    return this.addItemListener.asObservable();
  }

  public addItem(item: Item) {
    this.addItemListener.next(item);
  }

  public listenDeleteItem() {
    return this.deleteItemListener.asObservable();
  }

  public deleteItem(id) {
    this.deleteItemListener.next(id);
  }
}
